import {setTimeout} from "timers";
<template>
    <div>
        <el-card>
            <el-tabs v-model="activeName" @tab-click="handleClick" v-loading="loading">

                <el-tab-pane :label="item.name" :name="item.dashboard" v-for="(item,index) in dashboardList"
                             :key="index">
                    <div style="padding-left: 20px;" v-if="item.download==1">
                        <el-button type="primary"  >申请数据下载</el-button>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="生存分析" name="analyse" v-if="sk==1">
                    <Analyse ref="analyse"/>
                </el-tab-pane >
                <el-tab-pane label="统计报告" name="report" >
                    <el-row>
                        <div style="display: flex;justify-content: space-between">
                            <div>
                                <el-button @click="dowReport()" v-if="form.url"
                                           type="primary">下载报告
                                </el-button>
                                <el-button @click="Report(2)"
                                           type="warning">重新生成报告
                                </el-button>
                            </div>
                            <div style="float: right">{{form.reportTime}}生成报告</div>
                        </div>
                    </el-row>
                    <el-row style="display: flex;justify-content: center" >
                        <div class="title" v-if="!loading" >
                            <div>
                                <div style="font-size: 24px;font-weight: bold">中国成人白血病诊疗登记管理系统</div>
                                <div class="title2">{{ form.hospital }}登记数据报告</div>
                            </div>
                            <div>
                                <div class="title4">
                                    一、 登记系统背景介绍
                                </div>
                                <div class="title3">
                                    中国成人白血病诊疗登记管理系统是由国家卫生健康委员会主管并拥有版权；由上海交通大学瑞金医院和转化医学国家重大科技基础设施（上海）负责设计开发和技术支持，由上海交通大学网络信息中心负责网络安全支持，由全国省、地市级具有成人白血病诊疗能力的机构进行参与的白血病大数据系统。该系统的建立为了解中国成人白血病发病及诊疗状况，制定卫生政策提供客观依据。国家卫健委分批分阶段部署推进该项工作。目前覆盖了31个省（自治区、直辖市）和新疆生产建设兵团515个试点单位。
                                </div>
                            </div>
                            <div>
                                <div class="title4">
                                    二、 填报总体质量
                                </div>
                                <div class="title3">
                                    成人白血病诊疗登记管理系统涵盖白血病患者全生命周期数据，包含“基本信息”、“临床信息”、“细胞遗传”、“分子标志”、“免疫表型”、“治疗信息”和“转归费用”七个版块。所有版块数据指标均有信息填入，即为填报完成；所有版块填写的信息均为准确有效信息，则为填报准确（例如填写“不详”则为无效信息）。截止至{{form.year}}年{{form.month}}月{{form.day}}日，经质控，{{form.hospital}}登记数据整体情况如表1所示。
                                </div>
                                <div class="title5" style="padding: 20px 0">表1{{form.hospital}}病例填报情况（已审核病例）</div>
                                <el-table
                                        :data="tableData"
                                        border
                                        style="width: 100%">
                                    <el-table-column
                                            prop="hospital"
                                            align="center"
                                            label="单位"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                            prop="count"
                                            align="center"
                                            label="审核病例"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                            prop="wgcount"
                                            align="center"
                                            label="完成例数">
                                    </el-table-column>
                                    <el-table-column
                                            prop="wglv"
                                            align="center"
                                            label="完成率">
                                    </el-table-column>
                                    <el-table-column
                                            prop="zqcount"
                                            align="center"
                                            label="准确例数">
                                    </el-table-column>
                                    <el-table-column
                                            prop="zqlv"
                                            align="center"
                                            label="准确率">
                                    </el-table-column>
                                </el-table>
                                <div class="title3" style="padding-top: 30px">
                                    {{form.hospital}}病例填报的完成度是{{form.wglv}}%，表明已填报的数据总体上完成度{{form.wgtext}}。{{form.hospital}}病例填报的准确度是{{form.zqlv}}%，表明已填报的数据准确度{{form.zqtext}}。未完成病例在质控人员审核退回后，大部分病例均能根据审核意见进行补充完善，但仍有部分病例未能及时完善。
                                </div>
                            </div>
                            <div>
                                <div class="title4"> 三、 填报信息概况</div>
                                <div class="title4" style="padding: 20px 0 !important;"> 1、基本信息</div>
                                <div class="title3">
                                    截止至{{form.year}}年{{form.month}}月{{form.day}}日，白血病诊疗登记系统中{{form.hospital}}共登记{{form.count}}例白血病病例，已登记白血病病例的就诊年份分布如图1所示；性别分布如图2所示；就诊年龄分布如图3所示，中位年龄{{form.average}}；医保类型分布如图4所示；户籍省份分布如图5所示。
                                </div>
                                <div>
                                    <el-image :src="form.image1"></el-image>
                                    <div class="images">图1 已登记白血病病例就诊年份分布</div>
                                </div>
                                <div>
                                    <el-image :src="form.image2"></el-image>
                                    <div class="images">图2 已登记白血病病例的性别分布</div>
                                </div>
                                <div>
                                    <el-image :src="form.image3"></el-image>
                                    <div class="images">图3 已登记白血病病例的就诊年龄分布</div>
                                </div>
                                <div>
                                    <el-image :src="form.image4"></el-image>
                                    <div class="images">图4 已登记白血病病例的医保类型分布</div>
                                </div>
                                <div>
                                    <el-image :src="form.image5"></el-image>
                                    <div class="images">图5 已登记白血病病例的户籍省份分布</div>
                                </div>
                                <div class="title4" style="padding: 20px 0 !important;">2、诊断信息</div>
                                <div class="title3">
                                    在{{form.hospital}}已录入的数据中，急性髓系白血病（AML）的病例数共有{{form.jixing_chufacount}}例，占全部病例数的{{form.jixing_bilv}}%；急性淋巴细胞白血病（ALL）共有{{ form.zhiliao_count }}例，占全部病例数的{{ form.zhiliao_bilv}}%；其他诊断共有{{form.qita}}例，占{{form.qita_bilv}}%，如图6所示；已登记的AML病例诊断亚型分布如图7所示；已登记的ALL病例诊断亚型分布如图8所示。。
                                </div>
                                <div>
                                    <el-image :src="form.image6"></el-image>
                                    <div class="images">图6 已登记白血病病例的诊断分型分布</div>
                                </div>
                                <div>
                                    <el-image :src="form.image7"></el-image>
                                    <div  class="images">图7 已登记的AML诊断亚型分布</div>
                                </div>
                                <div>
                                    <el-image :src="form.image8"></el-image>
                                    <div  class="images">图8 已登记的ALL诊断亚型分布</div>
                                </div>
                                <div class="title4" style="padding: 20px 0 !important;">
                                    3、MICM信息
                                </div>
                                <div class="title3">
                                    MICM（细胞形态学、免疫表型、细胞遗传学、分子标志）是反映白血病专病特点的重要指标，是白血病患者精准分子分型和预后分层的基础，能更好地指导治疗方案的选择。MICM完整填报率一方面反映了不同地区和医疗机构白血病诊疗水平， 另一方面也能反映病例填报质量。已登记白血病病例的染色体核型信息如图9所示；分子标志信息如图10所示
                                </div>
                                <div>
                                    <el-image :src="form.image9"></el-image>
                                    <div class="images">图9已登记白血病病例的染色体核型信息 </div>
                                </div>
                                <div>
                                    <el-image :src="form.image10"></el-image>
                                    <div class="images">图10已登记白血病病例的分子标志信息 </div>
                                </div>
                            </div>
                            <div class="title4">4、治疗信息</div>
                            <div class="title3">
                                已登记白血病病例的缓解信息如图11所示；复发信息如图12所示；死亡信息如图13所示
                            </div>
                            <div>
                                <el-image :src="form.image11"></el-image>
                                <div class="images">图11 已登记白血病病例的缓解信息 </div>
                            </div>
                            <div>
                                <el-image :src="form.image12"></el-image>
                                <div class="images">图12 已登记白血病病例的复发信息</div>
                            </div>
                            <div>
                                <el-image :src="form.image13"></el-image>
                                <div class="images">图13 已登记白血病病例的死亡信息</div>
                            </div>
                            <div class="title4">5、转归预后</div>
                            <div class="title3">
                                白血病患者治疗效果和长期预后的评价有赖于完善齐全的随访资料。已登记白血病病例的生存状态如图14所示。
                            </div>
                            <div>
                                <el-image :src="form.image14"></el-image>
                                <div class="images">图14 已登记白血病病例的生存状态</div>
                            </div>

                            <div class="title4">备注：登记系统填报常见问题</div>
                            <div class="title3">
                                <span class="title5">1、病例质控：</span>
                                病例质控过程中发现各单位填报病例的常见问题包括：（1）出凝血指标单位换算问题（例如D-二聚体ug/L和mg/l的换算）；（2）患者基本信息不全；（3）患者联系方式未填；（4）免疫表型结果未填写完整；（5）未列出突变或具体基因异常不明确；（6）部分板块结果缺失较严重；（7）随访记录待更新；（8）失访比例过高；（9）治疗信息缺失；（10）退回病例未完善。
                            </div>
                            <div class="title3">
                                <span class="title5">2、MICM信息：</span>
                                MICM诊断信息是反映白血病专病特点的重要指标，齐全的MICM信息是白血病精准诊疗的重要基础。鼓励继续完善已填报病例的MICM信息，并上传MICM报告图片，便于人工智能识别报告图片、核实填报准确性。同时鼓励从第三方检验公司导出MICM检测结果进行填报。
                            </div>
                            <div class="title3">
                                <span class="title5">3、随访问题：</span>
                                预后分析中，部分单位已填报的白血病病例随访信息填写不全，或未进行随访。只有完善的长期随访信息才能获得更可靠的白血病预后评估及生存分析结果。初诊医院应每6个月对所有患者进行一次随访，对于后续未入院检查或住院治疗的病例，在年终总结完成电话随访。
                            </div>
                        </div>
                        <div style="height: 80vh"></div>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane label="分析工具(开发中)" name="tool" v-if="tool==1">
                    <el-row style="text-align: center">
                        <div style="padding: 0 20px ;">
                            <div class="tooltest">
                                <span>在线绘图工具 —— 简单易上手</span>
                            </div>
                            <img src="../../assets/images/tool1.jpg" style="width: 900px">
                        </div>
                        <div style="padding: 20px">
                            <div class="tooltest">
                                <span>开发中的绘图工具</span>
                            </div>
                            <img src="../../assets/images/tool2.png" style="width: 900px">
                        </div>
                    </el-row>
                </el-tab-pane>
                <div class="detail-body" v-if="activeName!='report' && activeName!='tool' && activeName != 'analyse'" :style="download?'margin-top:10px':''">
                    <iframe
                            :src="iframeUrl"
                            frameborder="0"
                            id="bdIframe"
                            allowtransparency
                            ref="iframe"
                    ></iframe>
                </div>
            </el-tabs>
            <el-footer class="footers" id="footers" v-if="activeName!='report' && activeName!='tool' && activeName != 'analyse'">
            </el-footer>
        </el-card>
    </div>
</template>

<script>
    import Analyse from './analyse'
    let _this = null;
    export default {
        components: {
            Analyse,
        },
        name: 'dashboard-index',
        data() {
            return {
                tableData: [
                    {
                        hospital: "",
                        "count": 0,
                        "wgcount": 0,
                        "wglv": 0,
                        "zqcount": 0,
                        "zqlv": 0,
                    }
                ],
                download:false,
                tool:localStorage.getItem('tool'),
                sk:localStorage.getItem('sk'),
                activeName: '',
                iframeUrl: '',
                dashboardList: '',
                loading: false,
                form: {
                    "reportTime":"",
                    "hospital": "",
                    "year": "",
                    "month": "",
                    "day": "",
                    "count": "",
                    "wgcount": "",
                    "wglv": "",
                    "zqcount": "",
                    "zqlv": "",
                    "average": "",
                    "qita": "",
                    "qita_bilv": "",
                    "wgtext": "",
                    "zqtext": "",
                    "jixing_chufacount": "",
                    "jixing_bilv": "",
                    "zhiliao_count": "",
                    "zhiliao_bilv": "",
                    "banduo_bilv": "",
                    "image1": "",
                    "image2": "",
                    "image3": "",
                    "image4": "",
                    "image5": "",
                    "image6": "",
                    "image7": "",
                    "image8": "",
                    "image9": "",
                    "image10": "",
                },
            }
        },
        created() {
            _this = this;
        },
        mounted() {
            _this = this;
            _this.onscroll();
            window.onresize = function () { // 定义窗口大小变更通知事件
                _this.onscroll()
            };
            const { iframe } = this.$refs;
            // IE和非IE浏览器，监听iframe加载事件不一样，需要兼容
            const that = this;
            if (iframe.attachEvent) {
                // IE
                iframe.attachEvent('onload', () => {
                    that.loading = false
                });
            } else {
                // 非IE
                iframe.onload = function () {
                    that.loading = false
                };
            }
            _this.getData();
        },
        methods: {
            dowReport() {
                window.location = window.location.href.split('#')[0] + _this.form.url
            },
            onscroll() {
                try {
                    const oIframe = document.getElementById('bdIframe');
                    const deviceHeight = document.documentElement.clientHeight;
                    var height = (Number(deviceHeight) - 155) + 'px';
                    if(_this.download){
                        height = (Number(deviceHeight) - 193) + 'px';
                    }
                    oIframe.style.height = height
                    const footer = document.getElementById("footers")
                    const devicew = document.documentElement.clientWidth;
                    footer.style.width = (Number(devicew) - 265) + 'px';
                    _this.loading = false
                } catch (e) {
                    console.log(e)
                }
            },
            async Report(num) {
                this.loading = true
                try {
                    const resp = await this.$http.get(`/metabase/report/model/?num=${num}`)
                    if (resp.data.code !=1) {
                        this.$message.error("报告生成失败！")
                    } else {
                        _this.form = resp.data.data
                        _this.tableData = [
                            {
                                hospital:  _this.form.hospital,
                                "count":  _this.form.countp,
                                "wgcount":  _this.form.wgcount,
                                "wglv":  _this.form.wglv + "%",
                                "zqcount":  _this.form.zqcount,
                                "zqlv":  _this.form.zqlv + "%",
                            }
                        ]
                        this.loading = false
                    }
                } catch (e) {
                    this.$message.error(e.message)
                }
                this.loading = false
            },
            getData() {
                _this.loading = true
                this.$http.get(`/auth/setting/view/`)
                    .then(resp => {
                        var data = resp.data
                        if (data.data) {
                            _this.dashboardList = data.data
                            var activeName = localStorage.getItem("activeName")
                            if (activeName == "analyse" && _this.sk==1){
                                _this.activeName = "analyse"
                            }else if(activeName == "report"){
                                _this.activeName = "report"
                            }
                            else {
                                _this.activeName = _this.dashboardList[0].dashboard
                            }
                        }
                        if(_this.activeName != "analyse" && _this.activeName != "report" ){
                            this.iframeUrl = _this.dashboardList[0].iframeUrl;
                        }else {
                            _this.loading = false
                        }
                    })
                    .catch((err) => {
                        _this.loading = false
                        console.log(err)
                    })
            },
            handleClick() {
                localStorage.setItem("activeName",_this.activeName)
                if (this.activeName != "report" && this.activeName != "tool"  && this.activeName != 'analyse') {
                    _this.iframeUrl = ""
                    _this.loading = true
                    _this.download = false
                    _this.dashboardList.forEach(function (item) {
                        if(_this.activeName == item.dashboard){
                            if(item.download == 1){
                                _this.download = true
                            }
                            _this.iframeUrl = item.iframeUrl
                            setTimeout(function () {
                                _this.onscroll()
                            }, 10)
                        }
                    })
                } else if(this.activeName == 'report') {
                    this.Report(1)
                }else if(this.activeName == 'analyse') {
                    this.$refs.analyse.getData();
                }
            },
        },
    };
</script>
<style scoped>
    .tooltest{
        padding: 20px;
        font-size: 22px;
        font-weight: bold;
    }
    .detail-body {
        width: 100%;
        /*height: 100vh;*/
        position: relative;
    }

    iframe {
        width: 100%;
        height: 100%;
        /*border: none;*/
    }

    .footers {
        height: 57px !important;
        bottom: 10px;
        /*width: 85%;*/
        /*right: 65px;*/
        /*left: 200px;*/
        position: fixed;
        background-color: #fff;
    }

    /deep/ .EmbedFrame-header, .EmbedFrame-footer {
        display: none;
    }

    /deep/ .el-card__body {
        padding-bottom: inherit !important;
    }

    .title2 {
        font-size: 20px;
        color: black;
        padding-top: 20px;
        padding-bottom: 50px;
    }

    .title3 {
        text-indent: 2em;
        line-height: 35px;
        font-size: 18px;
        text-align: initial;
        padding: 6px 0;
    }

    .title4 {
        text-align: left;
        font-size: 18px;
        font-weight: bolder;
        padding: 30px 0;
    }

    .title {
        margin: 30px 0px;
        text-align: center;
        width: 850px;
        letter-spacing: 2px;
        border-radius: 4px;
        padding: 30px;
        border: 1px solid #ebeef5;
        color: #303133;
        -webkit-transition: .3s;
        transition: .3s;
        box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);

    }

    .title5 {
        font-weight: bold;
    }

    /depp/ .el-table th.el-table__cell > .cell {
        font-size: 16px !important;
        color: black;
    }

    /deep/ .el-table th.is-leaf {
        border-bottom: 1px solid #EBEEF5;
        /*background-color: aliceblue;*/
    }

    /deep/ .block .el-form-item--mini.el-form-item, /deep/ .block .el-form-item--small.el-form-item {
        margin-bottom: 0px;
    }

    .title /deep/ .el-table .el-table__row .cell {
        color: black;
        /*font-weight: bold;*/
        font-size: 18px;
    }

    .title /deep/ .el-table th > .cell {
        font-weight: inherit;
        color: black;
        font-size: 18px;
    }

    .title /deep/ .el-table td, .title /deep/ .el-table th.is-leaf {
        border-bottom: 1px solid #0e0f0f;
    }


    .title /deep/ .el-table--border, .title /deep/ .el-table--group {
        border-left: 1px solid #0e0f0f;
        border-top: 1px solid #0e0f0f;
        border-right: 1px solid #0e0f0f;
        border-bottom: 1px solid #0e0f0f;
    }

    .title /deep/ .el-table--border th, .el-table__fixed-right-patch {
        border-bottom: 1px solid #0e0f0f;
    }

    .title /deep/ .el-table td, .title /deep/ .el-table th.is-leaf {
        border-bottom: 1px solid #0e0f0f;
    }

    .title /deep/ .el-table td, .title /deep/ .el-table th.is-leaf {
        border-bottom: 1px solid #0e0f0f;
    }

    .title /deep/ .el-table--border td, .title /deep/ .el-table--border th, .title /deep/ .el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
        border-right: 1px solid #1c1d1e;
    }

    .title /deep/ .el-table td, .title /deep/ .el-table th.is-leaf {
        border-bottom: 1px solid #0d0d0e;
    }

    .title /deep/ .el-table--border td, .title /deep/ .el-table--border th, .title /deep/ .el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
        border-right: 1px solid #28282b;
    }
    .images{
        font-weight: bold;
        padding: 20px;
    }
</style>
